import { FilterType } from "@/v2-components/pages/games/_type";

export const SUPPORT_TYPE_DESC = {
  mod: "Community-made haptics for games without official support.",
  native: "Official in-game haptics created by developers (Plug & Play).",
  "official-mod": "Official haptics made by bHaptics for supported games.",
  "ai-powered":
    "AI-generated haptics that adapt to gameplay in real time, no setup required.",
};

type FilterTab = {
  value: FilterType;
  label: string;
};

export const GAME_FILTER_TABS: FilterTab[] = [
  {
    value: "platform",
    label: "Platform",
  },
  {
    value: "device",
    label: "Device",
  },
  {
    value: "supportType",
    label: "Support Type",
  },
  {
    value: "genre",
    label: "Genre",
  },
];
